import { Navigate } from "react-router-dom";
import { useAtomValue } from "jotai";

import { currentPreferencesAtom, personaAtom } from "@/store";
import { isValidRouteForRole, getRoutesForRole } from "@/config/routes";

/**
 * Redirects the user to their preferred landing page.
 * Validates the stored route is allowed for the current persona's role,
 * falling back to the first available route for that role.
 */
export function DefaultRedirect() {
  const preferences = useAtomValue(currentPreferencesAtom);
  const persona = useAtomValue(personaAtom);

  const target = isValidRouteForRole(preferences.defaultRoute, persona.role)
    ? preferences.defaultRoute
    : (getRoutesForRole(persona.role)[0]?.path ?? "/home");

  return <Navigate to={target} replace />;
}
